import Banner from '@/components/banner'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/payment-assistance')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Banner backgroundUrl="/img/banner.jpg" containerStyle="h-[320px]" />
      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15 px-4 md:px-0">
          Payment Assistance
        </h1>
        <div className="card p-10">
          <p className="mb-4">
            We're here to help. Customers experiencing financial hardship have a
            right to apply for short-term assistance or long-term assistance and
            this assistance is provided free of charge.
          </p>
          <div className="container text-muted">
            <h3 className="text-xl font-bold">What is Financial Hardship?</h3>
            <p className="text-base mb-4">
              Financial hardship is where a customer is in circumstances where
              they are unable to meet their payment obligations but considers
              they will be able to meet these obligations if we agree to an
              arrangement for payment assistance. Circumstances that may affect
              a customer's ability to pay include illness, unemployment, reduced
              income, experiencing domestic or family violence, a death in the
              family, natural disasters and other unexpected events that change
              income or expenses.
            </p>

            <h3 className="text-xl font-bold">What assistance can we offer?</h3>
            <p className="text-base mb-2">
              We can offer a range of options to help you stay connected when
              you are experiencing financial hardship. Options that may be
              available include:
            </p>
            <ul className="mt-3 mb-4 ml-10 list-disc list-outside">
              <li>Temporarily extending time for payment</li>
              <li>
                Agreeing on a payment plan tailored to your ability to pay
              </li>
              <li>Discounting or waiving certain fees and charges</li>
              <li>
                Placing a restriction on part of your service or specific
                services
              </li>
              <li>
                Transferring you to a plan better suited to your circumstances
              </li>
              <li>Removing non-essential features of a service at no cost.</li>
            </ul>
            <p className="text-base mb-4">
              Many of our plans are month to month, allowing you to change or
              downgrade your plan to one that better suits your needs.
            </p>

            <h3 className="text-xl font-bold">How to apply?</h3>
            <p className="text-base mb-2">
              If you are having trouble paying your bill, wish to discuss
              options available to minimise your bill, or want to apply for
              financial hardship assistance contact us at:
            </p>
            <p className="text-base ml-4">
              Phone - 1300 30 40 38 (8am – 8pm AEST Monday - Friday)
            </p>
            <p className="text-base ml-4 mb-4">
              Email - <a href={`mailto:${SUPPORTEMAIL}`}>{SUPPORTEMAIL}</a>
            </p>

            <h3 className="text-xl font-bold">Financial Counselling</h3>
            <p className="text-base mb-2">
              If you are facing financial difficulty, you may wish to consider
              obtaining advice from a financial counsellor.
            </p>
            <p className="text-base mb-2">
              You can talk to a financial counsellor anywhere in Australia by
              contacting the National Debt Helpline by:
            </p>
            <ul className="mt-3 mb-4 ml-10 list-disc list-outside">
              <li>
                Calling 1800 007 007 – Free hotline is open from 9.30am to
                4:30pm Monday to Friday
              </li>
              <li>
                Live Chat at ndh.org.au – 9.00am to 8.00pm Monday to Friday
              </li>
            </ul>

            <h3 className="text-xl font-bold">Complaints</h3>
            <p className="text-base mb-2">
              We're genuinely here to help you. If you have a complaint about
              the outcome of your application for financial hardship assistance,
              you can contact us via:
            </p>
            <p className="text-base ml-4">Phone - {SUPPORTPHONE}</p>
            <p className="text-base ml-4">
              Email - <a href={`mailto:${SUPPORTEMAIL}`}>{SUPPORTEMAIL}</a>
            </p>
            <p className="text-base ml-4 mb-2">
              Online - <a href="/contact">Contact Us</a>
            </p>
            <p className="text-base mb-2">
              You can find more information on our Complaints Handling Policy{' '}
              <a href="/pdf/complaint-handling-policy.pdf" target="_blank">
                here
              </a>
              .
            </p>
            <p className="text-base mb-1">
              If you are unhappy with our handling of your complaint, you can
              also seek external dispute resolution through the
              Telecommunications Industry Ombudsman (TIO). You can make a
              complaint through the TIO by:
            </p>
            <ul className="mt-3 mb-4 ml-10 list-disc list-outside">
              <li>Calling 1800 062 058</li>
              <li>
                Contacting them at{' '}
                <a href="https://www.tio.com.au/" target="_blank">
                  www.tio.com.au
                </a>
              </li>
            </ul>
            <p className="text-base mb-2">
              Read the full{' '}
              <a href="#" target="_blank">
                Payment Assistance Policy
              </a>
            </p>
            <p className="text-base mb-2">
              Access our{' '}
              <a href="/pdf/financial-hardship-policy.pdf" target="_blank">
                Financial Hardship Policy
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
